import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, RECRUITMENT_INQUIRY_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const RECRUITMENT_INQUIRYS = GLOBAL_STATE

export const { reducer: recruitmentInquirySlice } = createSlice({
  name: RECRUITMENT_INQUIRYS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.recruitmentInquiryList.pending, state => {
        state[RECRUITMENT_INQUIRY_LIST].loading = true
      })
      .addCase(actionCreators.recruitmentInquiryList.rejected, (state, action) => {
        state[RECRUITMENT_INQUIRY_LIST].loading = false
        state[RECRUITMENT_INQUIRY_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.recruitmentInquiryList.fulfilled, (state, action) => {
        state[RECRUITMENT_INQUIRY_LIST].loading = false
        state[RECRUITMENT_INQUIRY_LIST].error = null
        state[RECRUITMENT_INQUIRY_LIST].data = action.payload
      })

    builder.addCase(actionCreators.recruitmentInquiryListClear, state => {
      state[RECRUITMENT_INQUIRY_LIST] = defaultState()
    })
  },
})
